const dig = (obj, attributePath) => attributePath.reduce((acc, attr) => acc[attr], obj);

const strComp = (a, b) => a.localeCompare(b);

const numComp = (a, b) => {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

export const sortByAttribute = (arr, attributePath, customComp = null) => {
  const copy = [...arr];
  const path = attributePath.split('.');

  return copy.sort((a, b) => {
    const aValue = dig(a, path);
    const bValue = dig(b, path);

    if (customComp) return customComp(aValue, bValue);
    if (typeof aValue === 'string') return strComp(aValue, bValue);
    if (typeof aValue === 'number') return numComp(aValue, bValue);

    return 0;
  });
};
